import React, { useMemo } from 'react';

import useDrive from '../../hooks/useDrive';
import GridCard from './GridCard';

import { GridContainer, EmptyState } from './Grid.styles';

const GridView = () => {
  const { items, currentFolder, search, setCurrentFolder, setBreadcrumbs } = useDrive();

  const data = useMemo(() => {
    const filtered = items.filter((item) => {
      const isCurrentFolder = item.parentId === currentFolder;

      const matchesSearch = item.name.toLowerCase().includes(search.toLowerCase());

      return isCurrentFolder && matchesSearch;
    });

    const folders = filtered.filter((item) => item.type === 'folder');

    const files = filtered.filter((item) => item.type === 'file');

    return [...folders, ...files];
  }, [items, currentFolder, search]);

  const handleOpen = (item) => {
    if (item.type !== 'folder') {
      return;
    }

    if (item.id === currentFolder) {
      return;
    }

    setCurrentFolder(item.id);

    setBreadcrumbs((prev) => {
      const existingIndex = prev.findIndex((breadcrumb) => breadcrumb.id === item.id);

      if (existingIndex >= 0) {
        return prev.slice(0, existingIndex + 1);
      }

      return [
        ...prev,
        {
          id: item.id,
          name: item.name,
        },
      ];
    });
  };

  if (!data.length) {
    return <EmptyState>No files or folders found.</EmptyState>;
  }

  return (
    <GridContainer>
      {data.map((item) => (
        <GridCard key={item.id} item={item} onOpen={handleOpen} />
      ))}
    </GridContainer>
  );
};

export default GridView;
